module.exports = __webpack_public_path__ + "img/chrome_reader_mode.5be82d0a.svg";